import {CheckoutService} from '../services'
import useStore from './useStore'
import {computed, watch, ref} from '@vue/composition-api'
import axios from 'axios'

const useStripe = () => {
    const {store} = useStore()

    const user = computed(() => store.state.user)

    const redirectToCheckout = async ({priceId, stripeInstance,referral}) => {

        try {

            let params = {
                priceId: priceId, 
                email: user.value.email,
                userId: user.value.userId,
                referral: referral
            }

            if(user.value.premiumPlan && user.value.premiumPlan.customerID){
                params.customer = user.value.premiumPlan.customerID
            }

            const response = await CheckoutService.createCheckoutSession(params)

            return stripeInstance.redirectToCheckout({sessionId: response.data.sessionId})
        } catch(err) {
            console.log(err)
        }
        
    }

    const changePayment = async url => {

        const sessionData = await axios.post(url, {
            customer: this.user.subscription.customerID, 
            subscription: this.user.subscription.subscriptionId
        })

        return sessionData
    }

    return {
        redirectToCheckout,
        changePayment
    }
}

export default useStripe